import { render, staticRenderFns } from "./HotelsFeedWidget.vue?vue&type=template&id=0384f32a&"
import script from "./HotelsFeedWidget.vue?vue&type=script&lang=js&"
export * from "./HotelsFeedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0384f32a')) {
      api.createRecord('0384f32a', component.options)
    } else {
      api.reload('0384f32a', component.options)
    }
    module.hot.accept("./HotelsFeedWidget.vue?vue&type=template&id=0384f32a&", function () {
      api.rerender('0384f32a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/HotelsFeedWidget.vue"
export default component.exports